import extend from 'lodash/extend';
import * as ActionTypes from './actionTypes';

const initialState = {
  tabIndex: 0,
  isFmoServiceInProgress: false,
  fmoDetail: {},
  selectedTabValue: 'tab1',
  isFMO: false,
  isPpaAgency: false,

  // New Properties
  producerDetails: {
    response: null,
    status: 'loading',
    error: null,
  },
};

export default function accountDetailsReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case ActionTypes.UPDATE_ACCOUNTDETAILS_TAB_INDEX:
      return extend({}, state, action.payload);
    case ActionTypes.SET_FMO_DETAILS:
      return extend({}, state, action.payload);
    case ActionTypes.REQUEST_PRODUCER_DETAILS_DATA:
      return extend({}, state, { producerDetails: { ...state?.producerDetails, status: 'loading' } });
    case ActionTypes.RECEIVE_PRODUCER_DETAILS_DATA:
      return extend({}, state, {
        producerDetails: { ...state?.producerDetails, response: action.payload, status: 'success' },
      });
      case ActionTypes.RECEIVE_PRINCIPAL_PRODUCER_DETAILS_DATA:
        return extend({}, state, {
          isAgencyPrincipalAssociatedWithFMO: action.payload,
        });
      case ActionTypes.PRINCIPAL_ASSOCIATED_WITH_FMO:
        return extend({}, state, {
          isPrincipalAssociatedWithFMO: action.payload,
        });
    case ActionTypes.PRODUCER_DETAILS_SERVICE_ERROR:
      return extend({}, state, {
        producerDetails: { ...state?.producerDetails, error: action.payload, status: 'error' },
      });
    case ActionTypes.BULKUPLOAD_OUTPUT_REQUEST:
      return extend({}, state, action.payload);
    case ActionTypes.SET_PRINCIPAL_USER_DETAILS:
        return extend({}, state, action.payload);
    case ActionTypes.UPDATE_APPOINTMENT_TAB_INDEX:
      return extend({}, state, action.payload);
    case ActionTypes.SET_FMO_OR_PPA_AGENCY_STATUS:
      return extend({}, state, action.payload);
    case ActionTypes.ALLOWED_AGENCY_DETAILS_DATA:
      return extend({}, state, action.payload);
    case ActionTypes.PRINCIPAL_ASSOCIATED_WITH_FMO:
      return extend({}, state, action.payload);
    case ActionTypes.PRINCIPAL_ASSOCIATED_WITH_FMO_DETAILS:
    return extend({}, state, action.payload);
    case ActionTypes.CONTACT_UPDATE_CAMPAIGN_DETAILS:
      return extend({}, state, action.payload);
    case ActionTypes.CONTACT_CONFIRMED:
      return extend({}, state, action.payload);
    default:
      return state;
  }
}
